import React from 'react';
import PropTypes from 'prop-types';
import MarketShare from 'components/partials/charts/ShareChart';
import {
  generateStationGroup,
  removeDuplicated,
  colors
} from '../ProductionDashboardHelpers';

export default function SummaryTab({ productionItems }) {
  // Aggregate data into a single array for the pie chart
  const aggregateData = () => {
    if (!productionItems || productionItems.length === 0) return [];
    
    return productionItems.map((station, index) => {
      const dataLength = station.key === 'sashAssembly' 
        ? removeDuplicated(station.value)?.length 
        : station.value.length;
        
      return {
        value: dataLength || 0,
        name: generateStationGroup(station.key) || 'Unknown',
        color: colors[index % colors.length]
      };
    }).filter(item => item.value > 0);
  };

  const chartData = aggregateData();
  const totalItems = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div>
      <h3>Summary Performance</h3>
      <div className="charts-grid">
        {chartData.length > 0 ? (
          <MarketShare
            data={chartData}
            radius={['95%', '83%']}
            title="Total Throughput by Station"
            summary={totalItems.toString()}
          />
        ) : (
          <div className="p-4 text-center border rounded">No throughput data available for summary.</div>
        )}
      </div>
    </div>
  );
}

SummaryTab.propTypes = {
  productionItems: PropTypes.array.isRequired
};
